import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <article>
        <CategoryGrid />
      </article>
      <article>
        <AboutSection />
      </article>
      <article>
        <ArticlePreview />
      </article>
      <section>
        <CTASection />
      </section>
      <article>
        <FAQSection />
      </article>
      <Footer />
    </main>
  );
}